import ANoticeListItem from './index.vue';

ANoticeListItem.install = app => {
  app.component(ANoticeListItem.name, ANoticeListItem);
};

export default ANoticeListItem;
